import i18n from "@Shared/@i18n";
export const FILL_OUT_SECTIONS = {
  PERSONAL_INFORMATION: "personal-details",
  PROPERTY: "property",
  MORTGAGE_DETAILS: "mortgage-details"
};
export const SETTINGS_TABS = () => [{
  key: "account",
  label: i18n.t("settings.tabs.account"),
  component: "account-container"
}, {
  key: "notifications",
  label: i18n.t("settings.tabs.notifications"),
  component: "notifications-container"
}];
export var APPLICATION_STEPS;
(function (APPLICATION_STEPS) {
  APPLICATION_STEPS["GOALS"] = "goals";
  APPLICATION_STEPS["SUBJECT_PROPERTY"] = "subject-property";
  APPLICATION_STEPS["APPLICANTS"] = "applicants";
  APPLICATION_STEPS["IDENTIFICATIONS"] = "identifications";
  APPLICATION_STEPS["INCOME_HISTORY"] = "income-history";
  APPLICATION_STEPS["ASSETS"] = "assets";
  APPLICATION_STEPS["LIABILITIES"] = "liabilities";
  APPLICATION_STEPS["OTHER_PROPERTIES"] = "other-properties";
  APPLICATION_STEPS["SUBMIT"] = "submit";
})(APPLICATION_STEPS || (APPLICATION_STEPS = {}));
export const FILL_OUT_PAGES = {
  [FILL_OUT_SECTIONS.PERSONAL_INFORMATION]: [APPLICATION_STEPS.APPLICANTS, APPLICATION_STEPS.IDENTIFICATIONS, APPLICATION_STEPS.INCOME_HISTORY, APPLICATION_STEPS.ASSETS, APPLICATION_STEPS.LIABILITIES, APPLICATION_STEPS.OTHER_PROPERTIES],
  [FILL_OUT_SECTIONS.MORTGAGE_DETAILS]: [APPLICATION_STEPS.GOALS],
  [FILL_OUT_SECTIONS.PROPERTY]: [APPLICATION_STEPS.SUBJECT_PROPERTY, APPLICATION_STEPS.GOALS]
};
export var LICENSE_TYPE;
(function (LICENSE_TYPE) {
  LICENSE_TYPE["blank"] = "blank";
  LICENSE_TYPE["broker"] = "broker";
  LICENSE_TYPE["agent"] = "agent";
  LICENSE_TYPE["associate"] = "associate";
  LICENSE_TYPE["mortgage-broker"] = "mortgageBroker";
  LICENSE_TYPE["chartered-mortgage-broker"] = "charteredMortgageBroker";
  LICENSE_TYPE["certified-real-estate-broker"] = "certifiedRealEstateBroker";
  LICENSE_TYPE["real-estate-broker"] = "realEstateBroker";
  LICENSE_TYPE["mortgage-real-estate-broker"] = "mortgageRealEstateBroker";
  LICENSE_TYPE["chartered-mortgage-real-estate-broker"] = "charteredMortgageRealEstateBroker";
})(LICENSE_TYPE || (LICENSE_TYPE = {}));